import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { SOCKET } from './Store/variable'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate';
import '@mdi/font/css/materialdesignicons.css'
import "@fortawesome/fontawesome-free/css/all.css";
import vMediaQuery from 'v-media-query'
import AppNotificationMixin from './components/mixins/AppNotificationMixin';
import AppMixin from './components/mixins/AppMixin.vue';
import LangsMixin from './components/mixins/LangsMixin';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2'
import appDialog from "@/components/Dialog/AppDialog.vue";
import ShareHelper from "@/components/helper/ShareHelper.vue";
import * as VueGoogleMaps from 'vue2-google-maps';
import MapHelper from "@/components/helper/MapHelper.vue";
import HtmlEditor from "@/components/helper/HtmlEditor.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue"
import VueConfirmDialog from 'vue-confirm-dialog';
import Loading from 'vue-loading-overlay';
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueUploadComponent from 'vue-upload-component'
import progressBar from "@/components/progressBar.vue";
import filterSelect from "@/components/filterSelect.vue";
import vuescroll from 'vuescroll';
import dialogActionMessage from "@/components/dialogActionMessage.vue";
import cookieLaw from "@/components/cookie_law.vue";
import DropdownMenu from '@innologica/vue-dropdown-menu';
import Switches from "vue-switches";
import VueSession from 'vue-session';
import VueMasonry from 'vue-masonry-css';

import Uploader from "@/components/Partials/Uploader.vue";
import WidgetToolbar from "@/components/widget/widgetToolbar.vue";
import widgetButton from "@/components/widget/widgetButton.vue";
import widgetSearch from "@/components/widget/widgetSearch.vue";
import widgetDropdownMenu from "@innologica/vue-dropdown-menu";
import widgetTabs from "@/components/widget/widgetTabs.vue";
import widgetProfile from "@/components/widget/widgetProfile.vue";
import widgetAscDesc from "@/components/widget/widgetAscDesc.vue";
import widgetInput from "@/components/widget/widgetInput.vue";
import widgetModal from "@/components/widget/widgetModal.vue";
import widgetWrapper from "@/components/widget/widgetWrapper.vue";
import widgetTags from "@/components/widget/widgetTags.vue";
import widgetSelect from "@/components/widget/widgetSelect.vue";
import widgetTextarea from "@/components/widget/widgetTextarea.vue";
import widgetDatePicker from "@/components/widget/widgetDatePicker.vue";
import widgetClassDropdown from "@/components/widget/widgetClassDropdown.vue";
import widgetAccountInput from "@/components/widget/widgetAccountInput.vue";
import widgetListSelecter from "@/components/widget/widgetListSelecter.vue";
import widgetCheckbox from "@/components/widget/widgetCheckbox.vue";
import widgetRitchEditor from "@/components/widget/widgetRitchEditor.vue";
import widgetFeedFilterLocation from "@/components/widgets/widgetFeedFilterLocation.vue"
import widgetNotFoundWidget from "@/components/widget/widgetNotFoundWidget.vue";
import widgetSearchLocalLocation from "@/components/widgets/widgetSearchLocalLocation.vue"
import widgetTagItem from "@/components/widget/widgetTagItem.vue"
import widgetWizard from "@/components/widget/widgetWizard.vue"
import TagsInput from "@/components/TagsInput.vue"
import dropdownMenu from "@/components/dropdownMenu.vue";
Vue.component('dropdownMenu', dropdownMenu);

import { Multipane, MultipaneResizer } from "vue-multipane";
Vue.component('Multipane', Multipane);
Vue.component('MultipaneResizer', MultipaneResizer);


Vue.component('TagsInput', TagsInput);

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)


Vue.use(VueMasonry);
Vue.use(VueSession);
Vue.use(VueLoading);
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage);

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCZu-doKWHHf8P68LQrzYAoFy-IZJBAJuQ',
        libraries: 'places',
    }
});

Vue.component('Loading', Loading);
Vue.component('file-upload', VueUploadComponent)
Vue.component('MapHelper', MapHelper);
Vue.component('HtmlEditor', HtmlEditor);
Vue.component('ShareHelper', ShareHelper);
Vue.component('appDialog', appDialog);
Vue.component('consultfiedButton', consultfiedButton);
Vue.component('cButton', consultfiedButton);
Vue.component('progressBar', progressBar);
Vue.component('filterSelect', filterSelect);
Vue.component('dialogActionMessage', dialogActionMessage);
Vue.component('cookieLaw', cookieLaw);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('Switches', Switches);

Vue.component('Uploader', Uploader);

Vue.component('WidgetToolbar', WidgetToolbar);
Vue.component('WidgetButton', widgetButton);
Vue.component('WidgetSearch', widgetSearch);
Vue.component('widgetDropdown', widgetDropdownMenu);
Vue.component('widgetTabs', widgetTabs);
Vue.component('widgetProfile', widgetProfile);
Vue.component('widgetAscDesc', widgetAscDesc)
Vue.component('widgetInput', widgetInput);
Vue.component('widgetModal', widgetModal);
Vue.component('widgetInputWrapper', widgetWrapper);
Vue.component('widgetTags', widgetTags);
Vue.component('widgetSelect', widgetSelect);
Vue.component('widgetTextarea', widgetTextarea);
Vue.component('widgetDatePicker', widgetDatePicker);
Vue.component('widgetClassDropdown', widgetClassDropdown);
Vue.component('widgetAccountInput', widgetAccountInput);
Vue.component('widgetListSelecter', widgetListSelecter);
Vue.component('widgetCheckbox', widgetCheckbox);
Vue.component('widgetRitchEditor', widgetRitchEditor);
Vue.component('widgetCheckbox', widgetCheckbox);
Vue.component('widgetFeedFilterLocation', widgetFeedFilterLocation);
Vue.component('widgetSearch', widgetSearch);
Vue.component('widgetDropdown', widgetDropdownMenu);
Vue.component('widgetInput', widgetInput);
Vue.component('widgetModal', widgetModal);
Vue.component('widgetInputWrapper', widgetWrapper);
Vue.component('WidgetButton', widgetButton);
Vue.component('widgetTabs', widgetTabs);
Vue.component('widgetNotFoundWidget', widgetNotFoundWidget);
Vue.component('widgetSearchLocalLocation', widgetSearchLocalLocation);
Vue.component('widgetTagItem', widgetTagItem);
Vue.component('widgetWizard', widgetWizard);

Vue.use(VueClipboard)
import VAnimateCss from "v-animate-css";
Vue.use(VAnimateCss);

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueGraph from 'vue-graph'
// import reactiveStorage from "vue-reactive-storage";
import Ripple from 'vue-ripple-directive'
import VueSocketIO from "vue-socket.io";
// import BootstrapVue from 'bootstrap-vue'
import adapter from 'webrtc-adapter';
import moment from 'moment'
import linkify from 'vue-linkify'
import StarRating from 'vue-star-rating'
import infiniteScroll from './libs/index'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'

Vue.use(vuescroll, {
    ops: {
        vuescroll: {
            locking: true,
            scroller: {
                /*
                  Allow to scroll out of boundaries
                  true or false or an array specify which direction can be
                  bounced. The options can be:
                  ['top','bottom','left','right']
                */
                bouncing: {
                    top: 100,
                    bottom: 100,
                    left: 100,
                    right: 100
                },
                /** Enable locking to the main axis if user moves only slightly on one of them at start */
                locking: true,
                /** Minimum zoom level */
                minZoom: 0.5,
                /** Maximum zoom level */
                maxZoom: 3,
                /** Multiply or decrease scrolling speed **/
                speedMultiplier: 1,
                /** This configures the amount of change applied to deceleration when reaching boundaries  **/
                penetrationDeceleration: 0.03,
                /** This configures the amount of change applied to acceleration when reaching boundaries  **/
                penetrationAcceleration: 0.08,
                /** Whether call e.preventDefault event when sliding the content or not */
                preventDefault: true,
                /** Whether call preventDefault when (mouse/touch)move*/
                preventDefaultOnMove: true,
                // whether to  disable scroller or not.
                disable: false
            }
        }
    },
});
Vue.use(Notifications, { velocity })
Vue.use(infiniteScroll)
Vue.component('star-rating', StarRating);
Vue.directive('linkified', linkify)
Vue.use(VueCookies)
VueCookies.config('1d')

// Vue.use(BootstrapVue)
Vue.use(adapter)
Vue.use(VueGraph)
import Meta from 'vue-meta';

Vue.use(Meta);
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './components/plugins/base'
import { stringify } from 'querystring';

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

Vue.use(Vuetify, {
    theme: {
        primary: "#173024",
        secondary: '#006837',
        accent: '#AAAA2D',
        error: '#b71c1c'
    }
});

import ReadMore from 'vue-read-more';
Vue.use(ReadMore);



// Set initial values
// Vue.use(reactiveStorage, {
//     "authToken": '',
//     "userId": ''
// });


//this ripple library is bringing conflicts
// Vue.directive('ripple', Ripple);

Vue.use(vMediaQuery)
Vue.use(VueCookies)
Vue.use(VueAxios, axios)
Vue.use(require('vue-moment'));

const config = {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: 'errors', // change if property conflicts
    events: 'input|blur',
    fieldsBagName: 'vee_validate_fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'en',
    validity: false,
    useConstraintAttrs: true
};
Vue.use(VeeValidate, config);
Vue.mixin(AppNotificationMixin); //Handles notifications message from any component E.g. errors messages
Vue.mixin(LangsMixin); //Handles localization in any component
Vue.mixin(AppMixin); //Handle some global app functions

Vue.use(new VueSocketIO({
    debug: false,
    //connection: 'http://127.0.0.1:3000/',
    connection: SOCKET,
    //connection: 'https://meritios.com',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }, //Optional options
    // options: { path: "/node/socket.io" }

}));


Vue.filter('validate', function (value) {
    if (value && value != "null" && value != '' && value != 'undefined' && value != 'Invalid date' && value != 'undefined') {
        return value
    } else {
        return "";
    }
});

Vue.filter('formatDate', function (value) {
    if (value && value !== 'null' && value !== '' && value !== '0000-00-00') {
        try {
            return moment.utc(String(value)).local().format(' D MMM, YYYY')
        } catch (e) {
            return value
        }
    }
});
Vue.filter('formatDateTime', function (value) {
    if (value && value !== 'null' && value !== '' && value !== '0000-00-00') {
        try {
            return moment.utc(String(value)).local().format("D MMM. YYYY, h:mm a")
        } catch (e) {
            return value
        }
    }
});
Vue.filter('formatTime', function (value) {
    if (value && value !== 'null' && value !== '' && value !== '0000-00-00') {
        try {
            return moment.utc(String(value)).local().format(' HH:mm')
        } catch (e) {
            return value
        }
    }
});
Vue.filter('best', function (value) {
    if (value && value !== 'null' && value !== '') {
        try {
            return moment.utc(String(value)).local().from(new Date());
        } catch (e) {
            return value
        }
    }
});



/*
   Add a response interceptor to take users to the login page
   to authenticate when the token from server expires
*/

axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    /*
       When the server responds with UnAuthorized access error,
       take back the user to the login page
    */
    console.log(error)
    try {
        if (error.response.status === 403) {
            store.commit("RESET", {})
            Vue.localStorage.remove("logged_user_data");
            router.push({ name: 'login' })
        }
    } catch (e) {
        console.log(e)
    }
    return Promise.reject(error);
});

let route = null;
router.beforeEach(
    (to, from, next) => {
        if (to.name === "welcome" && sessionStorage.isLogedIn === "true") {
            next('/feeds')
        }

        if (to.name === "settings") {
            if (parseInt(sessionStorage.getItem("account_type")) === 2) {
                next('/profile/customer/settings')
            } else {
                next()
            }
        } else {
            next()

        }
    }
)


// axios.interceptors.request.use(
//     (config) => {
//       let token = sessionStoragE.g.etItem('authToken');

//       if (token) {
//           let fn= token+token
//         config.headers['Authorization'] = `Bearer ${token}`;
//       }

//       return config;
//     }, 

//     (error) => {
//       return Promise.reject(error);
//     }
//   );

export const eventBus = new Vue();

// router.beforeEach((to, from, next) => {
//     eventBus.$emit('loading', {loading: true, reset: true});//To stop the loader on page switch
//     if (to.matched.some(record => record.meta.requiresAuth) && !window.$cookies.isKey('user')) {
//         next('/login');
//     }
//     next();
// })


let handleOutsideClick = null;

Vue.directive('closable', {
    bind(el, binding, vnode) {
        let handleOutsideClick = (e) => {
            e.stopPropagation()
            const { handler, exclude } = binding.value
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    if (vnode.context.$refs[refName]) {
                        const excludedEl = vnode.context.$refs[refName]
                        clickedOnExcludedEl = excludedEl.contains(e.target)
                    }
                }
            })
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]()
            }
        }
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind() {
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})


let handleOutsideClick2

Vue.directive('closable2', {
    bind(el, binding, vnode) {
        handleOutsideClick2 = (e) => {
            e.stopPropagation()
            const { handler, exclude } = binding.value
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    const excludedEl = vnode.context.$refs[refName]
                    clickedOnExcludedEl = excludedEl.contains(e.target)
                }
            })
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]()
            }
        }
        document.addEventListener('click', handleOutsideClick2)
        document.addEventListener('touchstart', handleOutsideClick2)
    },

    unbind() {
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})


Vue.config.productionTip = false


new Vue({
    router,
    store: store,

    render: h => h(App)
}).$mount('#app')